import { Component } from '@angular/core';
import { environment } from '../environments/environment';
import { PopupOcorrenciaService } from './popup-ocorrencia/popup-ocorrencia.service';
import { ApiConService } from './shared/api-con.service';
import { JsonReturn } from './interface/generic-interface';
import { IdentityApiTargetService } from './shared/identity-api-target.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [
    './app.component.css'
  ]
})
export class AppComponent {
  title = 'app';
  acessoLiberado = false;

  ngOnInit()
  {
    this.dadosAcesso();
  }  

  constructor(private  popupOcorrenciaService: PopupOcorrenciaService, private apiConService: ApiConService,  private apiPaineltarget : IdentityApiTargetService){}
  async dadosAcesso()
  {
    let base, usuario,data, ocRoteiro, roteiroAlertaId;
    const url = new URL(window.location.href);
    const rst = await this.apiPaineltarget.authPainelTarget();

    if(rst){

      if(rst?.code == 401)
      {
        document.body.innerHTML ="<h3>Acesso Expirado!</h3>"
        return;
      }

      if(rst?.sucesso){
        base = rst.response.dbName;
        usuario= rst.response.email;
        data = new Date().getUTCFullYear() + '-' + (new Date().getUTCMonth() + 1) + '-' + new Date().getUTCDate() + " " + new Date().getHours() + ":" + new Date().getMinutes()
      }

    }else{
      base  = atob(url.searchParams.get('opc1')!);
      usuario  = atob(url.searchParams.get('opc3')!);
      data  = atob(url.searchParams.get('opc4')!);
    } 

    ocRoteiro  = url.searchParams.get('opc6');
    roteiroAlertaId = url.searchParams.get('opc5')

    if(roteiroAlertaId){
      this.popupOcorrenciaService.roteiroAlertaId = atob(roteiroAlertaId);
    }

    if(ocRoteiro){
      this.popupOcorrenciaService.ocRoteiroBusca = JSON.parse(atob(ocRoteiro));
    }

    if(base != null && base != '' && usuario != null && usuario != '' && data != null && data != '')
    {
      this.popupOcorrenciaService.usuarioLogado = usuario;

      let dataAcesso = new Date(data);
      let diferenca = new Date().getTime() - dataAcesso.getTime();
      
      if(diferenca > 1800000)
      {
        document.body.innerHTML ="<h3 style='color:white;'>Acesso Expirado!</h3>"
        return;
      }
      else
      {
        environment.baseDados = base;
        environment.usuarioLogado = usuario;

        let retorno: JsonReturn = await this.configInicial()
        if(!retorno.sucesso)      {
          document.body.innerHTML =`
              <div id='conteudo' style='display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh;background: #fff'>
              <img src='/assets/imgs/logo_logistica.svg' alt='logo' style='width: 217px; height: 152px;'>
              <h1 class="mt-4 text-center"> ${retorno.msg} </h1>
              <h3 class="mt-3 text-center">Entre em contato com o suporte.</h3>
            </div>`;
          return;
        }
        this.acessoLiberado = true
      }
    }
    else
    {
      document.body.innerHTML ="<h3 style='color:white;'>Acesso Negado!</h3>"
      return;
    }
  }  

  async configInicial(): Promise<JsonReturn> {
    return await this.apiConService.patchInit();   
  }
}
